export default __webpack_public_path__ + "locales/sk/People.json?hash=8b31e292fe6b3c647a0329edc38795eb";